import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAppState } from '../../shared/appState/AppStateProvider';
import { useMe } from 'core/me/provider/MeProvider';
import { useCompanySettings } from 'core/companySettings';

export function AppGate() {
  const navigate = useNavigate();
  const loc = useLocation();

  const isRsvp = loc.pathname.startsWith('/rsvp/');
  const { me, loading: loadingMe } = useMe();

  // İstersen bunu da kaldırabiliriz; şimdilik sadece load için bırakıyorum
  const { loading: loadingSettings } = useCompanySettings();

  const { setSector } = useAppState();

  const loading = loadingMe || loadingSettings;

  useEffect(() => {
    if (isRsvp) return;
    if (loading) return;

    // 1) not authed
    if (!me) {
      if (loc.pathname !== '/sign-in') navigate('/sign-in', { replace: true });
      return;
    }

    // 2) email verify
    if (me.status === 'PENDING_EMAIL') {
      if (loc.pathname !== '/verify-email') {
        navigate('/verify-email', { replace: true, state: { email: me.email } });
      }
      return;
    }

    // 3) company role/type yoksa -> onboarding ekranın (bu senin eski onboarding sayfan)
    if (!me.companyType || !me.membershipRole) {
      if (!loc.pathname.startsWith('/app/onboarding')) {
        navigate('/app/onboarding', { replace: true });
      }
      return;
    }

    // 4) set sector
    const sector =
      me.companyType === 'PILATES' ? 'pilates' : me.companyType === 'PHYSIO' ? 'physio' : 'pilates';

    setSector(sector);

    // 5) /app root -> home
    if (loc.pathname === '/app' || loc.pathname === '/app/') {
      navigate('/app/pilates/sessions', { replace: true });
    }
  }, [isRsvp, loading, me, navigate, setSector, loc.pathname]);

  return <Outlet />;
}
